import React, { useContext, useEffect, useState } from "react";
import {
  styled,
  Table,
  TableContainer,
  TableHead,
  tableCellClasses,
  TableRow,
  TableCell,
  Paper,
  Button,
  Container,
  TablePagination,
  InputBase,
  IconButton,
  Autocomplete,
  TextField,
  Tooltip,
} from "@mui/material";
import apiService from "../../api/apiService";
import SearchIcon from "@mui/icons-material/Search";
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";
import DataContext from "../../context/DataContext";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import MemberDetails from "./MemberDetails";
import { Link } from "react-router-dom";
const SearchinputDiv = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#0aa4b466",
  "&:hover": {
    backgroundColor: "#0aa4b4b3",
  },
  color: "black",
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "25ch",
      "&:focus": {
        width: "27ch",
      },
    },
  },
}));
const communities = ["All", "General", "BC", "OBC", "SC", "ST"];
const genderList = ["All", "Male", "Female", "Transgender"];
const districts = [
  "All",
  "Chennai",
  "Coimbatore",
  "Madurai",
  "Trichy",
  "Tirunelveli",
  "Salem",
  "Erode",
  "Vellore",
  "Kanchipuram",
  "Thanjavur",
  "Tiruppur",
  "Kumarakom",
  "Villupuram",
  "Dindigul",
  "Cuddalore",
  "Nagapattinam",
  "Perambalur",
  "Pudukkottai",
  "Karur",
  "Sivaganga",
];
const statusList = [
  {
    id: 50,
    name: "All",
  },
  {
    id: 0,
    name: "Pending",
  },
  {
    id: 1,
    name: "Provisional Approved",
  },
  {
    id: 2,
    name: "Approved",
  },
];
const AdminList = () => {
  const { setPageLoading, getStatus } = useContext(DataContext);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchName, setSearchName] = useState("");
  const [count, setCount] = useState(0);
  const [communityName, setCommunityName] = useState("All");
  const [genderName, setGenderName] = useState("All");
  const [districtName, setDistrictName] = useState("All");
  const [status, setStatus] = useState(50);
  const [statusName, setStatusName] = useState("All");
  useEffect(() => {
    listApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchInputValue,
    rowsPerPage,
    page,
    communityName,
    genderName,
    districtName,
    status,
  ]);
  const handleSearch = (searchValue) => {
    if (searchValue.length > 3) {
      setSearchInputValue(searchValue);
      setPage(0);
    } else {
      setSearchInputValue("");
      setPage(0);
    }
    setSearchName(searchValue);
  };
  const handleSelectCommunity = (value) => {
    setCommunityName(value);
  };
  const handleGender = (val) => {
    setGenderName(val);
  };
  const handleDistrictChange = (district) => {
    setDistrictName(district);
  };
  const handleStatusChange = (value) => {
    setStatusName(value);
    const list = statusList.filter((data) => data.name === value);
    setStatus(list[0].id);
  };
  const handleClear = () => {
    setCommunityName("All");
    setGenderName("All");
    setDistrictName("All");
    setStatus(50);
    setStatusName("All");
  };
  const [listData, setListData] = useState([]);
  const listApi = () => {
    setListData([]);
    let req = {
      listSize: rowsPerPage,
      pageNumber: page + 1,
      searchString: searchInputValue,
      community: communityName !== "All" ? communityName : "",
      gender: genderName !== "All" ? genderName : "",
      district: districtName !== "All" ? districtName : "",
      status: status,
    };
    setPageLoading(true);
    apiService("user/list", req, "post")
      .then((result) => {
        setPageLoading(false);
        if (result?.data?.users) {
          setCount(result.data.count);
          setListData(result.data.users);
        }
      })
      .catch((err) => {});
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("pageScst", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem("rowsPerPageScst", parseInt(event.target.value, 10));
    localStorage.setItem("pageScst", 0);
    setPage(0);
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#F6F6F6",
      color: "#565E6C",
      borderBottom: "0px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      borderBottom: "0px",
    },
  }));

  return (
    <div style={{ paddingBottom: "50px" }}>
      <Container maxWidth="xl">
        <h5 className="mb-3">Registered Members</h5>
        <div className="table-div">
          <div className="mb-4 d-flex align-items-center">
            <div>
              <SearchinputDiv
                // sx={{ display: { xs: "none", sm: "block" } }}
                onChange={(e) => handleSearch(e.target.value)}
              >
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  value={searchName}
                  type="search"
                  placeholder="Search with Name"
                  inputProps={{ "aria-label": "search" }}
                />
              </SearchinputDiv>
            </div>
            <div className="ml-auto">
              <Button
                type="button"
                data-toggle="collapse"
                data-target="#collapseWidthExample"
              >
                <Tooltip title="Filter" placement="top">
                  <FilterAltIcon />
                </Tooltip>
              </Button>
            </div>
          </div>
          <div className="collapse my-3" id="collapseWidthExample">
            <div className="row justify-content-center align-item-center">
              <div className="col-lg-2 col-md-4 col-12 mb-2">
                <Autocomplete
                  options={genderList}
                  value={genderName}
                  onChange={(e, selectedOptions) =>
                    handleGender(selectedOptions)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Gender"
                      fullWidth
                      placeholder="Select Gender"
                    />
                  )}
                />
              </div>
              <div className="col-lg-2 col-md-4 col-12 mb-2">
                <Autocomplete
                  options={communities}
                  value={communityName ? communityName : ""}
                  onChange={(e, selectedOptions) =>
                    handleSelectCommunity(selectedOptions)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Community"
                      fullWidth
                      placeholder="Select Community Name"
                    />
                  )}
                />
              </div>
              <div className="col-lg-2 col-md-4 col-12 mb-2">
                <Autocomplete
                  options={districts}
                  onChange={(_, value) => {
                    handleDistrictChange(value); // Handle district change
                  }}
                  value={districtName}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="District"
                      variant="outlined"
                      fullWidth
                      placeholder="Select District"
                      // InputProps={{
                      //   ...params.InputProps,
                      //   startAdornment: (
                      //     <InputAdornment position="start">
                      //       <LocationCityIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                  )}
                />
              </div>
              <div className="col-lg-2 col-md-4 col-12 mb-2">
                <Autocomplete
                  // options={statusList}
                  options={statusList.map((list) => list.name)}
                  onChange={(_, value) => {
                    handleStatusChange(value); // Handle district change
                  }}
                  value={statusName}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Status"
                      variant="outlined"
                      fullWidth
                      placeholder="Select Status"
                      // InputProps={{
                      //   ...params.InputProps,
                      //   startAdornment: (
                      //     <InputAdornment position="start">
                      //       <LocationCityIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                  )}
                />
              </div>
              <div className="col-12 text-center mt-3">
                <Button
                  variant="contained"
                  onClick={() => handleClear()}
                  data-toggle="collapse"
                  data-target="#collapseWidthExample"
                >
                  Clear
                </Button>
              </div>
            </div>
          </div>
          {listData.length > 0 ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Id</StyledTableCell>
                    <StyledTableCell align="left">Name</StyledTableCell>
                    <StyledTableCell>Mobile Number</StyledTableCell>
                    <StyledTableCell>Email</StyledTableCell>
                    <StyledTableCell>Gender</StyledTableCell>
                    <StyledTableCell>District</StyledTableCell>
                    <StyledTableCell>Community</StyledTableCell>
                    <StyledTableCell align="center">Score</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                  </TableRow>
                </TableHead>

                {listData.map((list, index) => (
                  <TableRow key={index}>
                    <StyledTableCell component="th" scope="row" align="left">
                      {list.userName}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Link
                        to={`/admin/details/${btoa(list.id)}`}
                        className="c-blue"
                      >
                        {list.name}
                      </Link>
                      {/* <MemberDetails list={list} listApi={listApi} /> */}
                    </StyledTableCell>
                    <StyledTableCell>{list.phone}</StyledTableCell>
                    <StyledTableCell>
                      {list.email ? list.email : `-`}
                    </StyledTableCell>
                    <StyledTableCell>{list.gender}</StyledTableCell>
                    <StyledTableCell>{list.district}</StyledTableCell>
                    <StyledTableCell>{list.community}</StyledTableCell>
                    <StyledTableCell align="center">
                      {list.score}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <span style={{ color: getStatus(list.status).color }}>
                        {getStatus(list.status).statusName}
                      </span>
                      {/* {list.status === 0 ? "Pending" : "Provisional Approved"} */}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </Table>
              <TablePagination
                component="div"
                count={count}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{ float: "left" }}
                ActionsComponent={(paginationProps) => (
                  <CustomTablePaginationActions {...paginationProps} />
                )}
              />
            </TableContainer>
          ) : (
            <>
              <div className="p-5 text-center">
                <h3>Members data not available</h3>
              </div>
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default AdminList;

function CustomTablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ flexShrink: 0, marginLeft: "1rem" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
    </div>
  );
}
